import { useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";
import { Panel } from "@/components/core/AppLayout";

export const ToggleRow = ({ title, desc, checked, onChange, testid, disabled }) => (
  <div className="flex items-start justify-between gap-6 py-4 border-b border-[#5FB3EA]/60 last:border-0">
    <div>
      <div className="font-bold text-[#0A1128]">{title}</div>
      <div className="text-sm text-slate-600 mt-0.5">{desc}</div>
    </div>
    <Switch checked={checked} onCheckedChange={onChange} disabled={disabled} className="mt-1 data-[state=checked]:bg-[#E8173A] data-[state=unchecked]:bg-[#5FB3EA]" data-testid={testid} />
  </div>
);

const ITEMS = [
  { k: "riepilogo", title: "Riepilogo mattutino", desc: "Ogni giorno alle 09:00: task in scadenza e scadute, appuntamenti e post di oggi." },
  { k: "promemoria", title: "Promemoria per domani", desc: "Ogni giorno alle 18:00: appuntamenti e task in scadenza il giorno successivo." },
  { k: "assegnazione", title: "Avviso assegnazione task", desc: "Subito, quando un altro socio ti assegna una task." },
  { k: "richieste_sito", title: "Nuove richieste dal sito", desc: "Subito, quando arriva una richiesta di contatto o di link al portale da corefvg.com." },
];

export const NotificationSettings = ({ prefs, globali, onChange }) => {
  const [saving, setSaving] = useState(false);
  const toggle = async (k, v) => {
    const next = { ...prefs, [k]: v };
    setSaving(true);
    try {
      await api.put("/notifiche/mie", next);
      onChange(next);
      toast.success(v ? "Notifica attivata" : "Notifica disattivata");
    } catch (e) { toast.error(errMsg(e)); }
    finally { setSaving(false); }
  };
  return (
    <Panel className="p-8 core-rise core-delay-1" data-testid="my-notifications-panel">
      <h3 className="font-display text-xl font-extrabold text-[#0A1128] flex items-center gap-2 mb-1"><BellRing className="h-5 w-5 text-[#E8173A]" />Le mie email</h3>
      <p className="text-sm text-slate-600 mb-2">Scegli quali email automatiche ricevere. Orari secondo il fuso Europe/Rome.</p>
      {ITEMS.map((i) => (
        <ToggleRow key={i.k} title={i.title} checked={!!prefs[i.k]} onChange={(v) => toggle(i.k, v)} disabled={saving} testid={`notif-mine-${i.k}`}
          desc={globali && !globali[i.k] ? `${i.desc} (al momento disattivata per tutti dall'amministratore)` : i.desc} />
      ))}
    </Panel>
  );
};
